/** Expand only the current request; do not change the filter's saved target wiring. */
export function dropdownRefreshTargets(
  targets: Array<Record<string, unknown>>,
  filters: Array<{ componentId: string; label: string; field: string }>,
  sourceId: string,
  previousValue: unknown,
  value: unknown,
): Array<Record<string, unknown>> {
  const values = (raw: unknown): string[] => Array.isArray(raw)
    ? raw.map(String)
    : raw == null || raw === '' ? [] : [String(raw)];
  const selected = values(value);
  const removed = values(previousValue).some((entry) => !selected.includes(entry));
  const refresh = selected.length === 0 ? filters : removed
    ? filters.filter((filter) => filter.componentId === sourceId)
    : [];
  const result = [...targets];
  const seen = new Set(targets.map((target) => String(target['componentId'] ?? '')));
  refresh.forEach((filter) => {
    if (filter.componentId && !seen.has(filter.componentId)) {
      result.push(filter);
      seen.add(filter.componentId);
    }
  });
  return result;
}
